module.exports = __webpack_public_path__ + "img/IMG_6984_FoamcoreMatted.1e4e83b9.jpg";